import { ImageInfo, StickerItem, StickerMsg } from '../../../typings/proto';
import ImApi from '../../api/im';
import { logger } from '../../../util/logger';

class StickerManager {
  private static instance: StickerManager;
  public static getInstance(): StickerManager {
    if (!StickerManager.instance) {
      StickerManager.instance = new StickerManager();
    }

    return StickerManager.instance;
  }

  private list: StickerItem[] = [];

  constructor() {
    this.getList();
  }

  /// 本来应该 根据返回来插入新表情， 后台接口没有回传id消息， 直接拉新的, 方法暂时弃用
  public addSticker(imageInfo: ImageInfo | StickerMsg): void {
    const toSticker = {
      url: imageInfo.url,
      md5: imageInfo.md5sum,
      w: imageInfo.width,
      h: imageInfo.height,
      origUrl: imageInfo.url,
      id: '',
      name: '',
      packageId: '',
    };
    this.list.unshift(toSticker);
  }

  public updateList(): Promise<void> {
    return this.getList();
  }

  public get stickerList(): StickerItem[] {
    return this.list;
  }

  private getList(): Promise<void> {
    return ImApi.getCollectStickerList().then((result) => {
      this.list = result;
    })
      .catch((e) => {
        logger.error('StickerManager, getList fail, err', e);
      });
  }
}

export {
  StickerManager,
};
